import { Phone, AtSign, Printer, Mail } from "lucide-react";
import ContactInfo from "@/components/IconLabelable";

export default function ContactDetails() {
    return (
        <div className="flex flex-row gap-12 sm:gap-24 lg:gap-16 justify-center items-start">
            <div className="flex flex-col flex-nowrap space-y-3">
                <a href="tel:+18474264075"><ContactInfo icon={<Phone />} text="(847) 426-4075" /></a>
                <a href="mailto:evtcert@evtcc.org"><ContactInfo icon={<AtSign />} text="evtcert@evtcc.org" /></a>
                <ContactInfo icon={<Printer />} text="(847) 426-4076" />
            </div>

            <ContactInfo icon={<Mail />} align="center">
                <div className="flex flex-col flex-nowrap space-y-3">
                    <p className="font-bold inline">EVTCC</p>
                    <p>P.O.&nbsp;Box&nbsp;894</p>
                    <p className="my-0">Dundee,&nbsp;IL&nbsp;60118</p>
                </div>
            </ContactInfo>
        </div>
    );
}